import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'

const ToxicologyTests = () => {
  return (
    <div id='website-responsive'  style={{ overflow:'hidden'}}>
        <div className='py-md-5 pb-lg-0 display-block-1050 displaynone left-padding10rem1 right-padding10rem1' style={{ padding:'', }} >
        <div className='py-md5 displaynone display-block-1050 left-padding5rem1 right-padding5rem1' style={{ padding:'', }} >
            <center>
                <div className='bg-ss-secondary rounded10' style={{ boxShadow:'5px 3px 12px 0 rgba(0,0,0,.5)' }}>
                    <Row style={{ padding:'25px'}} className=''>
                        <Col md='3' lg='3' className='border-end border-white fs-ss-20 text-montserrat fw-700 text-white text-hover-black' style={{ cursor:'pointer'}}><Link to='/toxicology-and-drug-testing-chicago' className='text-white text-hover-black' style={{ textDecoration:'none'}}>Toxicology <br/> Testing</Link></Col>

                        <Col md='2' lg='2' className='border-end border-white fs-ss-20 text-montserrat fw-700 text-white text-hover-black' style={{ cursor:'pointer'}}><Link to='/blood-test-lab-in-chicago' className='text-white text-hover-black' style={{ textDecoration:'none'}}>Blood <br/> Testing</Link></Col>

                        <Col md='4' lg='4' className='border-end border-white fs-ss-20 text-montserrat fw-700 text-white text-hover-black' style={{ cursor:'pointer'}}><Link to='/respiratory-pathogen-panel-testing-in-chicago' className='text-white text-hover-black' style={{ textDecoration:'none'}}>Respiratory Pathogen <br/> Panel Testing</Link></Col>

                        <Col md='3' className='border-ed border-bl fs-ss-20 text-montserrat fw-700 text-white text-hover-black' style={{ cursor:'pointer'}}><Link to='/covid-and-rt-pcr-test-in-chicago-il' className='text-white text-hover-black' style={{ textDecoration:'none'}}>Covid-19 <br/> Testing</Link></Col>
                    </Row>
                </div>
            </center>
        </div>
        </div>
    </div>
  )
}

export default ToxicologyTests